import { render } from "./ChooseProject.vue?vue&type=template&id=03d2e364&scoped=true"
import script from "./ChooseProject.vue?vue&type=script&lang=js"
export * from "./ChooseProject.vue?vue&type=script&lang=js"

import "./ChooseProject.vue?vue&type=style&index=0&id=03d2e364&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-03d2e364"

export default script